import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import {Button, Popup, Picker, Icon, RadioGroup, Radio, Dialog, List, Toast, Uploader, DatetimePicker, NoticeBar  } from 'vant'
import '@/style/index.less'
import Layout from './components/Layout'
import http from './request/http'
import './permission'
import LocationPlugin from './plugin/LocationPlugin'

// store.commit('setToken', 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhdWQiOiIxMjk4NTAzODUxNTU3OTM3MTUzIiwiZXhwIjoxNjA4MzQzMjc3fQ.LZXpV7QZO0_4N134ZXC22IWrpb8-x7-4_gTelWLd1G0');

Vue.prototype.$req = http;
Toast.allowMultiple(true);

Vue.config.productionTip = false;

Vue.component(Button.name, Button);
Vue.component(Popup.name, Popup);
Vue.component(Picker.name, Picker);
Vue.component(Icon.name, Icon);
Vue.component(Layout.name, Layout);
Vue.component(RadioGroup.name, RadioGroup);
Vue.component(Radio.name, Radio);
Vue.use(Dialog);
Vue.use(List);
Vue.use(Toast);
Vue.use(Uploader);
Vue.use(DatetimePicker);
Vue.use(NoticeBar);

Vue.use(LocationPlugin);

Vue.filter('safeGetter', function (value, field) {
  if (value) {
    return value[field];
  } else {
    return null;
  }
});

Vue.filter('fillEmpty', function (value) {
  return value || '--';
});

window.app = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');